import React from 'react';
import { Eraser } from 'lucide-react';

export default function SignaturePad({ onChange }) {
  const ref = React.useRef(null);
  const drawing = React.useRef(false);
  const hasInk = React.useRef(false);

  React.useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#111827';
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext('2d'); ctx.lineTo(...pos(e)); ctx.stroke(); hasInk.current = true; };
  const up = () => { if (!drawing.current) return; drawing.current = false; if (hasInk.current) onChange(ref.current.toDataURL('image/png')); };
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); hasInk.current = false; onChange(null); };

  return (
    <div className="relative">
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-40 rounded-xl border-2 border-dashed border-slate-300 bg-white touch-none cursor-crosshair" data-testid="signature-pad" />
      <span className="absolute left-4 bottom-3 text-[11px] text-slate-300 pointer-events-none select-none">Sign above this line</span>
      <button type="button" onClick={clear} className="absolute right-2 top-2 inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs text-slate-500 hover:bg-slate-100" data-testid="signature-clear">
        <Eraser className="w-3.5 h-3.5" /> Clear
      </button>
    </div>
  );
}
